import {gql} from '@apollo/client';

const GetBusPartnersCostYears = gql`
  query GetBusPartnersCostYears {
    busPartnersCostYears {
      busPartnerId
      years
    }
  }
`;

export default GetBusPartnersCostYears;
